module.exports = __webpack_public_path__ + "static/media/bg-reencauche.8e749707.jpg";